import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api/axios';

const ctCfg = {
  phone:{label:'Telefon',icon:'📞',color:'bg-blue-100 text-blue-700'},
  email:{label:'Email',icon:'✉️',color:'bg-purple-100 text-purple-700'},
  meeting:{label:'Toplanti',icon:'🤝',color:'bg-emerald-100 text-emerald-700'},
  visit:{label:'Ziyaret',icon:'🚗',color:'bg-amber-100 text-amber-700'}
};
const stageLbl = {lead:'Lead',qualified:'Nitelikli',proposal:'Teklif',negotiation:'Muzakere',won:'Kazanildi',lost:'Kaybedildi'};
const stageClr = {lead:'bg-gray-100 text-gray-600',qualified:'bg-blue-100 text-blue-700',proposal:'bg-violet-100 text-violet-700',negotiation:'bg-amber-100 text-amber-700',won:'bg-emerald-100 text-emerald-700',lost:'bg-red-100 text-red-600'};

export default function CustomerDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [deals, setDeals] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [cf, setCf] = useState({ contact_type:'phone', notes:'' });
  const [tab, setTab] = useState('contacts');
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const [c, ct, d] = await Promise.all([api.get('/customers/'+id), api.get('/customers/'+id+'/contacts'), api.get('/deals')]);
      setCustomer(c.data); setContacts(ct.data); setDeals(d.data.filter(x => x.customer_id === id));
    } catch { navigate('/customers'); }
  };
  useEffect(() => { load(); }, [id]);

  const addContact = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await api.post('/customers/'+id+'/contacts', cf); setShowForm(false); setCf({contact_type:'phone',notes:''}); load(); }
    catch(err) { alert('Hata: ' + (err.response?.data?.detail || 'Hata')); }
    finally { setSaving(false); }
  };

  if (!customer) return <div className="flex items-center justify-center h-64 text-gray-400">Yukleniyor...</div>;

  return (
    <div className="space-y-5 animate-fadein">
      <button onClick={() => navigate('/customers')} className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-indigo-600 font-medium mb-2">← Musteriler</button>

      <div className="card p-6">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="w-16 h-16 rounded-2xl bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-2xl flex-shrink-0">{customer.full_name[0].toUpperCase()}</div>
          <div className="flex-1">
            <h1 className="text-2xl font-bold text-gray-800">{customer.full_name}</h1>
            {customer.company_name && <p className="text-gray-500">{customer.company_name}</p>}
            <div className="flex flex-wrap gap-3 mt-2">
              {customer.phone && <span className="text-sm text-gray-600">📞 {customer.phone}</span>}
              {customer.email && <span className="text-sm text-gray-600">✉️ {customer.email}</span>}
              {customer.city && <span className="text-sm text-gray-600">📍 {customer.city}</span>}
            </div>
          </div>
          <button onClick={() => setShowForm(true)} className="btn-primary self-start">+ Iletisim Ekle</button>
        </div>
        <div className="grid grid-cols-3 gap-4 mt-5 pt-5 border-t border-gray-100 text-center">
          <div><div className="text-2xl font-bold text-gray-800">{contacts.length}</div><div className="text-xs text-gray-500">Iletisim</div></div>
          <div><div className="text-2xl font-bold text-gray-800">{deals.length}</div><div className="text-xs text-gray-500">Deal</div></div>
          <div><div className="text-2xl font-bold text-gray-800">{deals.filter(d=>d.stage==='won').length}</div><div className="text-xs text-gray-500">Kazanilan</div></div>
        </div>
      </div>

      <div className="flex gap-1 bg-gray-100 p-1 rounded-xl w-fit">
        {[['contacts','Iletisim ('+contacts.length+')'],['deals','Deallar ('+deals.length+')']].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} className={"px-4 py-2 rounded-lg text-sm font-semibold transition-all " + (tab===k ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700')}>{l}</button>
        ))}
      </div>

      {tab === 'contacts' && (
        <div>
          {contacts.length === 0 ? (
            <div className="card p-10 text-center">
              <div className="text-4xl mb-3">💬</div>
              <div className="font-semibold text-gray-600">Henuz iletisim kaydı yok</div>
              <button onClick={() => setShowForm(true)} className="btn-primary mt-4 inline-flex">+ Iletisim Ekle</button>
            </div>
          ) : (
            <div className="card overflow-hidden">
              {contacts.map(c => {
                const cfg = ctCfg[c.contact_type] || {label:c.contact_type,icon:'💬',color:'bg-gray-100 text-gray-600'};
                return (
                  <div key={c.id} className="p-4 flex gap-4 hover:bg-gray-50 border-b border-gray-50 last:border-0">
                    <div className={"w-10 h-10 rounded-xl flex items-center justify-center text-xl flex-shrink-0 " + cfg.color.split(' ')[0]}>{cfg.icon}</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className={"text-xs font-semibold px-2 py-0.5 rounded-full " + cfg.color}>{cfg.label}</span>
                        <span className="text-xs text-gray-400">{new Date(c.contacted_at).toLocaleDateString('tr-TR',{day:'numeric',month:'long',year:'numeric'})}</span>
                      </div>
                      {c.notes && <p className="text-sm text-gray-700 mt-1.5">{c.notes}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {tab === 'deals' && (
        <div className="space-y-3">
          {deals.length === 0 ? (
            <div className="card p-10 text-center"><div className="text-4xl mb-3">💼</div><div className="text-gray-600 font-semibold">Bu musteriye ait deal yok</div></div>
          ) : deals.map(d => (
            <div key={d.id} className="card p-4 flex items-center gap-4">
              <div className="flex-1">
                <div className="font-semibold text-gray-800">{d.title}</div>
                {d.expected_value && <div className="text-sm text-gray-500">{Number(d.expected_value).toLocaleString('tr-TR')} TL</div>}
              </div>
              <span className={"text-xs font-semibold px-2.5 py-1 rounded-full " + (stageClr[d.stage]||'bg-gray-100 text-gray-600')}>{stageLbl[d.stage]||d.stage}</span>
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setShowForm(false)}>
          <div className="modal animate-slideup">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-lg font-bold">Iletisim Ekle</h2>
              <button onClick={() => setShowForm(false)} className="text-gray-400 hover:text-gray-600">✕</button>
            </div>
            <form onSubmit={addContact} className="space-y-4">
              <div className="grid grid-cols-4 gap-2">
                {Object.entries(ctCfg).map(([k,c]) => (
                  <button key={k} type="button" onClick={() => setCf({...cf, contact_type:k})}
                    className={"flex flex-col items-center gap-1 p-3 rounded-xl border-2 text-xs font-medium transition-all " + (cf.contact_type===k ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-gray-200 hover:border-gray-300 text-gray-600')}>
                    <span className="text-xl">{c.icon}</span><span>{c.label}</span>
                  </button>
                ))}
              </div>
              <textarea value={cf.notes} onChange={e => setCf({...cf,notes:e.target.value})} rows={4} className="input resize-none" placeholder="Notlar..." />
              <div className="flex gap-2">
                <button type="submit" disabled={saving} className="btn-primary flex-1">{saving ? 'Kaydediliyor...' : 'Kaydet'}</button>
                <button type="button" onClick={() => setShowForm(false)} className="btn-secondary flex-1">Iptal</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
